<template>
  <v-dialog v-model="newCompetitionModalVisible" max-width="1000px" class="ma-0 pa-0">
    <!--<v-btn slot="activator" color="#000000" dark class="add-button mb-2">Lisää tuote</v-btn>-->
    <v-card class="ma-0 pa-0">
      <v-container grid-list-md class="pt-2 pb-4 add-product-container">
        <v-row wrap class="">
          <v-col cols="7">
            <v-row no-gutters>
              <v-col cols="12" class="mt-3">
                <span class="headline">{{newCompetitionModalData ? 'Muokkaa kilpailun tietoja' : 'Lisää kilpailun tiedot'}} </span>
              </v-col>    
              <v-col cols="6" class="pt-2 pr-3">
                <v-text-field 
                  v-model="newCompetition.name" 
                  label="Kilpailun nimi*" 
                  :error-messages="errors.name"
                  @keyup="v => v !== '' ?  errors.name = '' :  ''"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="pb-0 pt-2">
                <v-autocomplete
                  class="pa-0 darker-placeholder"
                  v-model="newCompetition.metric"
                  :items="metrics"
                  :error-messages="errors.metric"
                  @change="e => metricSelected(e)"
                  placeholder="Mittari*"
                  persistent-hint
                  item-text="text"
                  item-value="id"
                  dense
                />
              </v-col>
              <!-- <v-col cols="6" class="pt-2 pr-3">
                <v-text-field 
                  v-model="newCompetition.userGoal" 
                  label="Myyjän tavoite" 
                  :error-messages="errors.userGoal"
                  @keyup="v => v !== '' ?  errors.name = '' :  ''"
                  dense
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="pt-2">
                <v-text-field 
                  v-model="newCompetition.teamGoal" 
                  label="Tiimin tavoite" 
                  :error-messages="errors.teamGoal"
                  @keyup="v => v !== '' ?  errors.name = '' :  ''"
                  dense
                  type="number"
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" md="12" class="pb-0 pt-2">
                <v-textarea 
                  class="pa-0"
                  single-line 
                  rows=2
                  :auto-grow="true" 
                  v-model="newCompetition.description" 
                  dense 
                  label="Kuvausteksti (ei pakollinen)" 
                  hide-details>
                </v-textarea>
              </v-col>
              <v-col cols="6" class="pr-3">
                <v-menu
                  :nudge-right="40"
                  transition="fade-transition"
                  offset-y
                  min-width="30px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      label="Aloituspäivä"
                      :error-messages="errors.startDate"
                      v-model="newCompetition.startDate"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="newCompetition.startDate"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  :nudge-right="40"
                  transition="fade-transition"
                  offset-y
                  min-width="30px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      label="Lopetuspäivä"
                      :error-messages="errors.endDate"
                      v-model="newCompetition.endDate"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="newCompetition.endDate"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="12" class="pb-0 pt-2">
                <v-autocomplete
                  :disabled="newCompetition.metric === 'margins' || newCompetition.metric === 'orders'"
                  class="pa-0 darker-placeholder"
                  v-model="newCompetition.products"
                  :items="getCatalogProductsAndVariations"
                  label="Tuotteet (voidaan käyttää vain myynti mittarille)"
                  persistent-hint
                  multiple
                  item-text="text"
                  item-value="value"
                  dense
                />
              </v-col>
              <v-col cols="12" md="12" class="pb-0 pt-2">
                <v-autocomplete
                  :disabled="newCompetition.metric === 'margins' || newCompetition.metric === 'orders'"
                  class="pa-0 darker-placeholder"
                  v-model="newCompetition.productsPreviousYear"
                  :items="getCatalogProductsAndVariations"
                  label="Viime vuoden tuotteet (suodata tällä viime vuoden lukua)"
                  persistent-hint
                  multiple
                  item-text="text"
                  item-value="value"
                  dense
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="5" class="mt-4">
            <v-row no-gutters style="border:1px solid #ccc;">
              <v-col cols="2" class="text-left pr-2" style="border-right:1px solid #ccc;"><span class="pl-2" style="font-size:10px;font-weight:600;">Myyjä</span></v-col>
              <v-col cols="2" class="text-right pr-2" style="border-right:1px solid #ccc;"><span class="pl-2" style="font-size:8px;font-weight:600;">Viim. vuosi</span></v-col>
              <v-col cols="4" class="text-center pr-2" style="border-right:1px solid #ccc;"><span class="pl-2" style="font-size:10px;font-weight:600;">Kasvuprosentti</span></v-col>
              <v-col cols="2" class="text-right pr-2"><span class="" style="font-size:10px;font-weight:600">Tavoite</span></v-col>
              <v-col cols="2" class="text-right pr-2"><span class="" style="font-size:10px;font-weight:600">Tulos</span></v-col>
            </v-row>
            <!-- ALL -->
            <v-row v-if="newCompetition.salespersons['all']" :key="'new-competition-all'" no-gutters style="border-bottom:1px solid #ccc;border-left:1px solid #ccc;border-right:1px solid #ccc;" class="pa-0 ma-0">
              <v-col cols="2" class="text-left pr-2" style="border-right:1px solid #ccc;">
                <span class="pl-2" style="font-size:10px">{{newCompetition.salespersons['all'].name}}</span>
              </v-col>
              <v-col cols="2" class="text-right pr-1" style="border-right:1px solid #ccc;">
                <div style="display:inline-block;text-align:center;">
                  <div class="prices-calculated-cell">{{Number(newCompetition.salespersons['all'].previousYearResult).toFixed(0)}}</div>
                </div>
              </v-col>
              <v-col cols="4" class="text-left" style="border-right:1px solid #ccc;">
                <v-row no-gutters style="background:#f3f3f3">
                  <!-- <v-col cols="4" style="border-right:1px solid #ccc">
                    <div style="display:inline-block;background:#f3f3f3;" class="goal-input pr-1">
                    </div>
                  </v-col>
                  <v-col cols="4" style="border-right:1px solid #ccc" class="text-right">
                    <div style="display:inline-block;" class="goal-input pr-1">
                    </div>
                  </v-col>
                  <v-col cols="4" class="text-center">
                  </v-col> -->
                </v-row>
              </v-col>
              <v-col cols="2" class="text-right" style="border-right:1px solid #ccc;">
                <div style="display:inline-block;" class="goal-input pr-1">
                  <span class="pl-2" style="font-size:10px">{{newCompetition.salespersons['all'].goal}}</span>
                  <!-- <input placeholder="5" :value="formatInput(newCompetition.salespersons['all'].goal)" type="tel"  class="prices-input-cell"> -->
                </div>
              </v-col>
              <v-col cols="2" class="text-right pr-2" style="border-right:1px solid #ccc;">
                
                  <span class="pl-2" style="font-size:10px">{{accruedResults['all'] ? Number(accruedResults['all']).toFixed(0) : 0}}</span>
                  <!-- <div class="prices-calculated-cell">{{accruedResults['all'] ? Number(accruedResults['all']).toFixed(0) : 0}}</div> -->
                
              </v-col>
            </v-row>
            <!-- SALESPERSONS -->
            <v-row v-for="s in getSalespersonsInOrder" :key="'new-competition-'+s.name" no-gutters style="border-bottom:1px solid #ccc;border-left:1px solid #ccc;border-right:1px solid #ccc;" class="pa-0 ma-0">
              <v-col cols="2" class="text-left pr-2" style="border-right:1px solid #ccc;">
                <span class="pl-2" style="font-size:10px">{{s.name}}</span>
              </v-col>
              <v-col cols="2" class="text-right pr-1" style="border-right:1px solid #ccc;">
                <div style="display:inline-block;text-align:center;">
                  <div class="prices-calculated-cell">{{formatInput(Number(s.previousYearResult).toFixed(0))}}</div>
                </div>
              </v-col>
              <v-col cols="4" class="text-left" style="border-right:1px solid #ccc;">
                <v-row no-gutters>
                  <v-col cols="4" style="border-right:1px solid #ccc">
                    <div style="display:inline-block;background:#f3f3f3;" class="goal-input pr-1">
                      <input placeholder="5" :value="s.growthPercentage" @change="v => setGrowthPercentage(v, s)" type="tel"  class="prices-input-cell">
                    </div>
                  </v-col>
                  <v-col cols="4" style="border-right:1px solid #ccc" class="text-right">
                    <div style="display:inline-block;" class="goal-input pr-1">
                      <div class="prices-calculated-cell">{{formatInput(Number(s.previousYearResult * (1+(s.growthPercentage)/100)).toFixed(0))}}</div>
                    </div>
                  </v-col>
                  <v-col cols="4" class="text-center">
                    <v-icon size="12"  @click="setGoal(s)" color="#666">far fa-arrow-alt-circle-right</v-icon>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="2" class="text-right" style="border-right:1px solid #ccc;">
                <div style="display:inline-block;background:#f3f3f3;" class="goal-input pr-1">
                  <input placeholder="5" @change="v => setCustomGoal(s,v)" :value="formatInput(s.goal)" type="tel"  class="prices-input-cell">
                </div>
              </v-col>
              <v-col cols="2" class="text-right" style="border-right:1px solid #ccc;">
                <div style="display:inline-block;background:#f3f3f3;" class="goal-input pr-1">
                  <div class="prices-calculated-cell">{{accruedResults[s.id] ? Number(accruedResults[s.id]).toFixed(0) : 0}}</div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        
      </v-container>
      <v-card-actions class="pb-4">
        <v-spacer></v-spacer>
        <!-- <v-btn color="avecor-button-global add-button mb-2 mr-1" outlined small @click="close">Peruuta</v-btn> -->
        <v-btn color="avecor-button-global add-button mb-2" outlined small @click="addItem" @keyup.enter="addItem()">{{newCompetitionModalData ? 'Tallenna muutokset' : 'Lisää'}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import shared from './../../shared'
import firebase from 'firebase'

var db = null



export default {
    props:[],
    data: () => ({
      accruedResults:{},
      autogrow:true,
      metricsTOBE:[{id:'sales',text:"Myynti"},{id:'margins',text:"Kate"},{id:'orders',text:"Tilaukset"},{id:'newCustomers',text:"Uudet Asiakkaat"},{id:'agreedVisits',text:"Sovitut Tapaamiset"}],
      metrics:[{id:'sales',text:"Myynti"},{id:'margins',text:"Kate"},{id:'orders',text:"Tilaukset"}],
      editedIndex: -1,
      newCompetition: {
        name:'',
        description:"",
        metric:'',
        startDate:"",
        endDate:"",
        products:[],
        productsPreviousYear:[],
        userGoal:"",
        teamGoal:"",
        salespersons:{}
      },
      defaultCompetition: {
        name:'',
        description:"",
        metric:'',
        startDate:"",
        endDate:"",
        products:[],
        productsPreviousYear:[],
        userGoal:"",
        teamGoal:"",
        salespersons:{}
      },
      errors: {
        name:"",
        description:"",
        metric:"",
        startDate:"",
        endDate:"",
        products:"",
        userGoal:"",
        teamGoal:""
      },
      defaultErrors: {
        name:"",
        description:"",
        metric:"",
        startDate:"",
        endDate:"",
        products:"",
        userGoal:"",
        teamGoal:""
      }
       
    }),
    watch: {
      startDate:{
        handler(val, oldVal){
          if(val === oldVal) return
          if(this.newCompetition.startDate && this.newCompetition.endDate && this.newCompetition.metric){
            this.resetCompetition()
            this.generateCompetitionActualData()
          }
        },
        deep:true
      },
      endDate:{
        handler(val, oldVal){
          if(val === oldVal) return
          if(this.newCompetition.startDate && this.newCompetition.endDate && this.newCompetition.metric){
            this.resetCompetition()
            this.generateCompetitionActualData()
          }
        },
        deep:true
      },
      metric:{
        handler(val, oldVal){
          if(val === oldVal) return
          if(this.newCompetition.startDate && this.newCompetition.endDate && this.newCompetition.metric){
            this.resetCompetition()
            this.generateCompetitionActualData()
          }
        },
        deep:true
      },
      newCompetitionModalVisible:{
        handler(val, oldVal){
          if(!val) this.newCompetitionModalData = null
          if(this.newCompetitionModalData) {
            this.newCompetition = {...this.defaultCompetition, ...this.newCompetitionModalData}
          }
          else {
            this.newCompetition = Object.assign({}, this.defaultCompetition)
            this.resetCompetition()
            this.generateCompetitionActualData()
          }
          this.errors = Object.assign({}, this.defaultErrors)
        },
      },
      /* newCompetition:{
        handler(val, oldVal){
          console.log(val)
          console.log("HERE")
          if (this.newCompetition.metric === 'margins') this.newCompetition.products = []
        },
        deep:true
      } */
      
    },
    mounted() {
      db = firebase.firestore();
      this.resetCompetition()

    },

    computed: {
      getSalespersonsInOrder(){
        var arr = []
        var all = null
        Object.keys(this.newCompetition.salespersons).forEach(sId => {
          if(sId === 'all') all = this.newCompetition.salespersons[sId]
          else arr.push(this.newCompetition.salespersons[sId])
        })
        arr.sort((a,b)=>{
          var nameA= a.name.trim(), nameB=b.name.trim();
          if (nameA > nameB) {
            return 1;
          }
          if (nameB > nameA) {
            return -1;
          }
          return 0;
        })
        return arr
      },
      metric(){
        return this.newCompetition.metric
      },
      startDate(){
        return this.newCompetition.startDate
      },
      endDate(){
        return this.newCompetition.endDate
      },
      marginMetricSelected(){
        if (this.newCompetition.metric === 'margins') return true
        return false
      },
      
      getCatalogProductsAndVariations(){
        var products = this.products
        var productVariations = this.productVariations
        var t = this
        var catalogProducts = []
        Object.keys(productVariations).map(function(key, index) {
          var pv = productVariations[key]
          products[pv.productId] ? catalogProducts.push({text: products[pv.productId].name.fi + " - " + t.createVariationName(pv), value: pv.id}) : ''//console.log(key)
          return ""
        })
        return catalogProducts.sort((a,b)=>{
          var nameA= a.text.trim(), nameB=b.text.trim();
          if (nameA > nameB) {
            return 1;
          }
          if (nameB > nameA) {
            return -1;
          }
          return 0;
        })

      },
      getSalespersons(){
        var staff = this.staff
        var salespersons = []
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if(s.role === 'sales' || s.role === 'ceo' || s.id ==='RqjgIwdXWzXqCR2MOVr1etp2iY22') salespersons.push({text:s.firstName, id:s.id})
          return {...s}
        })
        return salespersons
      },
      
      ...mapFields({
        settings:"settings",
        staff:"staff.staff",
        productVariations:"productVariation.productVariations",
        products:"product.products",
        orderedProducts:"orderedProduct.orderedProducts",
        orders:"order.orders",
        user:'user',
        newCompetitionModalVisible:"modals.report.competition.new.visible",
        newCompetitionModalData:"modals.report.competition.new.data",
      })
    },
    created () {
      this.createVariationName = shared.createVariationName
    },
    methods: {
      formatInput(v){
        if(isNaN(Number(v))){
          console.log("NAN")
          console.log(v)
        }
        var num = Number(v).toLocaleString()
        return num.replaceAll(',',' ')
      },
      setGoal(s){
        var comp = JSON.parse(JSON.stringify(this.newCompetition))
        var goal = Number(s.previousYearResult * (1+(s.growthPercentage)/100)).toFixed(0)
        comp.salespersons[s.id].goal = goal
        var totalGoal = 0
        Object.keys(comp.salespersons).forEach(sId => {
          if (sId !== 'all') totalGoal += Number(comp.salespersons[sId].goal)
        })
        comp.salespersons['all'].goal = totalGoal
        this.newCompetition = comp
      },
      setCustomGoal(s,v){
        var g = v.target.value
        g = g.replace(" ", '')
        g = g.trim()
        g = Number(g)
        var comp = JSON.parse(JSON.stringify(this.newCompetition))
        comp.salespersons[s.id].goal = g
        var totalGoal = 0
        Object.keys(comp.salespersons).forEach(sId => {
          if (sId !== 'all') totalGoal += Number(comp.salespersons[sId].goal)
        })
        comp.salespersons['all'].goal = totalGoal
        this.newCompetition = comp
      },
      setGrowthPercentage(v, s){
        var comp = JSON.parse(JSON.stringify(this.newCompetition))
        comp.salespersons[s.id].growthPercentage = v.target.value
        this.newCompetition = comp
      },
      resetCompetition(){
        var comp = JSON.parse(JSON.stringify(this.newCompetition))
        this.getAllActiveSalespersons().forEach(s => {
          comp.salespersons[s.id] = {
            name: s.firstName,
            id:s.id,
            growthPercentage:comp.salespersons[s.id] && comp.salespersons[s.id].growthPercentage ? comp.salespersons[s.id].growthPercentage : 0,
            goal:comp.salespersons[s.id] && comp.salespersons[s.id].goal ? comp.salespersons[s.id].goal : 0,
            previousYearResult:0
          }
        })

        comp.salespersons['all'] = {
          name: "Kaikki",
          growthPercentage:comp.salespersons['all'] && comp.salespersons['all'].growthPercentage ? comp.salespersons['all'].growthPercentage : 0,
          goal:comp.salespersons['all'] && comp.salespersons['all'].goal ? comp.salespersons['all'].goal : 0,
          previousYearResult:0
        }
        this.newCompetition = comp
      },
      getAllActiveSalespersons(){
        var salespersons = []
        for (const key in this.staff){
          if(this.staff[key].role === 'sales' && !this.staff[key].isExit) salespersons.push({firstName:this.staff[key].firstName, id:key})
        }
        return salespersons
      },
      generateCompetitionActualData(){
        var orderedProducts = this.orderedProducts
        var orders = this.orders
        var c = this.newCompetition
        var accruedResults = {}
        
        Object.keys(this.orderedProducts).forEach(function(key, index) {
          var op = orderedProducts[key]
          if(orders[op.orderId] === undefined) {return}
          var salespersonId = orders[op.orderId].salesperson
            var startDate = new Date(c.startDate)
            var startDateOneYearBefore = new Date(new Date(c.startDate).setFullYear(new Date(c.startDate).getFullYear() - 1))
            var endDate = new Date(c.endDate)
            var endDateOneYearBefore = new Date(new Date(c.endDate).setFullYear(new Date(c.endDate).getFullYear() - 1))
            var opCreatedDate = new Date(op.created_at.seconds * 1000)
            // PREVIOUS YEAR
            if(startDateOneYearBefore < opCreatedDate && endDateOneYearBefore > opCreatedDate){
              
              var continuee = false
              if(c.productsPreviousYear.length === 0) continuee = true
              else if(c.productsPreviousYear.length > 0 && c.productsPreviousYear.includes(op.productVariationId)) continuee = true
              if(!continuee) return
              
              if(c.metric === 'sales') {
                var total = op.unitPrice && op.quantity ? op.unitPrice * op.quantity : 0
                total += op.unitPrintPrice && op.printQuantity ? op.unitPrintPrice * op.printQuantity : 0
                total += op.pricePerPositioning && op.numberOfPositionings ? op.pricePerPositioning * op.numberOfPositionings : 0
                total = Math.round(Number(total))
                if(c.salespersons[salespersonId]){
                  c.salespersons[salespersonId].previousYearResult += total
                }
                c.salespersons['all'].previousYearResult += total
              }
            }
            // THIS YEAR
            if(startDate < opCreatedDate && endDate > opCreatedDate){
              var continuee = false
              if(c.products.length === 0) continuee = true
              else if(c.products.length > 0 && c.products.includes(op.productVariationId)) continuee = true
              if(!continuee) return
              
              if(c.metric === 'sales') {
                var total = op.unitPrice && op.quantity ? op.unitPrice * op.quantity : 0
                total += op.unitPrintPrice && op.printQuantity ? op.unitPrintPrice * op.printQuantity : 0
                total += op.pricePerPositioning && op.numberOfPositionings ? op.pricePerPositioning * op.numberOfPositionings : 0
                total = Math.round(Number(total))
                if(c.salespersons[salespersonId]){
                  accruedResults[salespersonId] ? '' : accruedResults[salespersonId] = 0
                  accruedResults[salespersonId] += total
                  c.salespersons[salespersonId].result += total
                }
                accruedResults['all'] ? '' : accruedResults['all'] = 0
                accruedResults['all'] += total
                c.salespersons['all'].result += total
              }
            }
        })
        Object.keys(this.orders).forEach(function(key, index) {
          var o = orders[key]
          var salespersonId = o.salesperson
          var startDate = new Date(c.startDate)
          var startDateOneYearBefore = new Date(new Date(c.startDate).setFullYear(new Date(c.startDate).getFullYear() - 1))
          var endDate = new Date(c.endDate)
          var endDateOneYearBefore = new Date(new Date(c.endDate).setFullYear(new Date(c.endDate).getFullYear() - 1))
          var oCreatedDate = new Date(o.created_at.seconds * 1000)
          // PREVIOUS YEAR
          if(startDateOneYearBefore < oCreatedDate && endDateOneYearBefore > oCreatedDate){
            if(c.metric === 'margins'){
              if(c.salespersons[salespersonId]){
                c.salespersons[salespersonId].previousYearResult += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
              }
              c.salespersons['all'].previousYearResult += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
            }
            if(c.metric === 'orders'){
              if(c.salespersons[salespersonId]){
                c.salespersons[salespersonId].previousYearResult += 1
              }
              c.salespersons['all'].previousYearResult += 1
            }
          }
          // THIS YEAR
          if(startDate < oCreatedDate && endDate > oCreatedDate){
            if(c.metric === 'margins'){
              if(c.salespersons[salespersonId]){
                
                accruedResults[salespersonId] ? '' : accruedResults[salespersonId] = 0
                accruedResults[salespersonId] += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
                c.salespersons[salespersonId].result += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
              }
              accruedResults['all'] ? '' : accruedResults['all'] = 0
              accruedResults['all'] += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
              c.salespersons['all'].result += o.salespersonMargin ? Math.round(Number(o.salespersonMargin)) : 0
            }
            if(c.metric === 'orders'){
              if(c.salespersons[salespersonId]){
                accruedResults[salespersonId] ? '' : accruedResults[salespersonId] = 0
                accruedResults[salespersonId] += 1
                c.salespersons[salespersonId].result += 1
              }
              accruedResults['all'] ? '' : accruedResults['all'] = 0
              accruedResults['all'] += 1
              c.salespersons['all'].result += 1
            }
          }
        })
        this.accruedResults = accruedResults
      },
      metricSelected(e){
        if(e === 'margins' || e === 'orders') this.newCompetition.products = []
      },
      createCompetition(){
          var timestamp = db.firestore.FieldValue.serverTimestamp()
          const competitionsRef = db.collection('competitions').doc()
          const competitionId = competitionsRef.id
          competitionsRef.set({
            id:competitionId,  
            created_at:timestamp,
            created_by:this.user.uid,
            ...this.newCompetition
          })
        
      },
      
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      close () {
        this.newCompetitionModalVisible = false
        //console.log("CLOSING DIALOG")
        //console.log(this.newCompetitionModalVisible)
        this.newCompetitionModalData = null
        setTimeout(() => {
          this.newCompetition = Object.assign({}, this.defaultCompetition)
          this.editedIndex = -1
        }, 300)
      },
      async addItem () {

        /* console.log(this.newCompetition)
        return */

        var errors = false
        //console.log(this.newCompetition)
        if(this.newCompetition.name.trim() === '') {this.errors.name = "Kilpailun nimi lisättävä"; errors = true}
        else {this.errors.name = ""}
        if(this.newCompetition.metric === '') {this.errors.metric = "Kilpailulle määriteltävä mittari"; errors = true}
        else {this.errors.metric = ""}
        if(this.newCompetition.startDate === '') {this.errors.startDate = "Aloituspäivä määriteltävä"; errors = true}
        else this.errors.startDate = ""
        if(this.newCompetition.endDate === '') {this.errors.endDate = "Lopetuspäivä määriteltävä"; errors = true}
        else this.errors.endDate = ""
        //if(this.newCompetition.userGoal === '') {this.errors.userGoal = "Tavoite määriteltävä"; errors = true}
        //else this.errors.userGoal = ""
        /* if(this.errors.userGoal === '' && this.newCompetition.userGoal.includes(',') ) {this.errors.userGoal = "Älä käytä pilkkua tavoitteessa"; errors = true}
        else this.errors.userGoal = ""
        if(this.errors.userGoal === '' && (this.newCompetition.userGoal.includes(',') || this.newCompetition.userGoal.includes('.'))) {this.errors.userGoal = "Käytä vain kokonaislukuja tavoitteessa"; errors = true}
        else this.errors.userGoal = ""
        if(this.errors.userGoal === '' && isNaN(Number(this.newCompetition.userGoal))) {this.errors.userGoal = "Luku on virheellinen. Käytä vain numeroita."; errors = true} */
        if (errors) return
        this.newCompetition.userGoal = Number(this.newCompetition.userGoal)

        var timestamp = firebase.firestore.FieldValue.serverTimestamp()
        if(this.newCompetitionModalData){
          db.collection('competitions').doc(this.newCompetitionModalData.id).set({
            ...this.newCompetition
          })  
        }
        else{
          const competitionsRef = db.collection('competitions').doc()
          const competitionId = competitionsRef.id
          competitionsRef.set({
            id:competitionId,  
            created_at:timestamp,
            created_by:this.user.uid,
            ...this.newCompetition
          })
        }
        this.close()
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/AddCompetition.vue